import { Gcms_Asset } from '@ep/types/gatsbyTypes';
import Maybe from 'graphql/tsutils/Maybe';

interface Page {
  title: string;
  metaTitle: string;
  description: string;
  metaDescription: string;
  structuredData?: string;
  slug: string;
  featuredImage?: Maybe<Gcms_Asset>;
  websiteType?: string;
  type?: string;
  topic?: string;
  tags?: string[];
}

function getSeoProps({
  title,
  metaTitle,
  description,
  metaDescription,
  structuredData,
  slug,
  featuredImage,
  websiteType,
  type,
  topic,
  tags,
}: Page) {
  const featuredImageUrl = featuredImage?.url;

  return {
    title,
    metaTitle,
    description,
    metaDescription,
    structuredData,
    slug,
    featuredImageUrl,
    websiteType,
    type,
    topic,
    tags,
  };
}

export default getSeoProps;
